import styled from "styled-components";

export const SettingsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    text-align: left;
    div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    h2 {
        font-size: 22px;
        font-weight: 700;
        margin: 0;
    }
    p {
        font-size: 14px;
        color: #6b7280;
        margin: 8px 0 0 0;
    }
`;

export const Card = styled.div`
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    @media (max-width: 600px) {
        padding: 20px 16px;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-end;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SectionLabel = styled.p`
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    text-align: left;
`;

export const SectionDesc = styled.p`
    font-size: 13px;
    color: #6b7280;
    margin: 0;
    text-align: left;
`;

export const SecondaryButton = styled.button`
    height: 48px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(147, 51, 234, 0.1);
    color: #9333ea;
    border-radius: 12px;
    border: 1px solid rgba(147, 51, 234, 0.2);
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    &:hover {
        background: rgba(147, 51, 234, 0.18);
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const PrimaryButton = styled.button`
    height: 48px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #9333ea;
    color: white;
    border-radius: 12px;
    border: none;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 8px 18px rgba(147, 51, 234, 0.25);
    opacity: ${({ $faded }) => ($faded ? 0.45 : 1)};
    &:hover {
        filter: brightness(1.05);
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const Toggle = styled.label`
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;

    input {
        display: none;
    }
`;

export const Slider = styled.div`
    width: 44px;
    height: 24px;
    background: #d1d5db;
    border-radius: 999px;
    position: relative;
    transition: 0.3s;

    &:after {
        content: "";
        position: absolute;
        top: 2px;
        left: 2px;
        width: 20px;
        height: 20px;
        background: white;
        border-radius: 50%;
        transition: 0.3s;
    }

    ${Toggle} input:checked + & {
        background: #6366f1;
    }

    ${Toggle} input:checked + &:after {
        transform: translateX(20px);
    }
`;
